module.exports = __webpack_public_path__ + "5b5f8cc9c271585065f3c64c34ccf3ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/header_logo_2x.png
// module id = 90
// module chunks = 0 1 2 3 4